import {
    Container,
    Form,
    Button,
    Row,
    Col
    // InputGroup,
    // FormControl
  } from "react-bootstrap";
  
  import { useForm,setValue } from "react-hook-form";
  import { useNavigate, useLocation } from "react-router-dom";
  import { useState,useEffect }  from "react";
  import "../../../../css/common.css";
  import * as VhfLang from "../VhfLang";

  import * as Const from "../../../common/const"
  import ShipInfo from "../eq/ShipInfo";
  import InputHelperBootstrap from "../../../helper/InputHelperBootstrap"
  import StepperHelper from "../../../helper/stepperHelper/StepperHelper"

 var isPostBack=false;

  const PrivateContact = () => {
    

    
    const navigate = useNavigate();
    const {state} = useLocation();
    const [specialPostAddress,setSpecialPostAddress]=useState(sessionStorage.getItem(VhfLang.SpecialPostAddressId)==='true');
    const [noSwedishPersonNo,setNoSwedishPersonNo]=useState(sessionStorage.getItem(VhfLang.NoSwedishPersNoId)==='true');
  
    const {
      unregister,
      setValue ,
      register,
      handleSubmit,
      watch,
      getValues,
      formState: { errors }
    } = useForm();
  
  

    //set values from session storage
      var values=JSON.parse(sessionStorage.getItem(VhfLang.KeyForSessionForPrivateContact));
      if(values!=null&&isPostBack==false){
        setValue(VhfLang.FirstnameId,values[VhfLang.FirstnameId]) 
        setValue(VhfLang.LastnameId,values[VhfLang.LastnameId]) 
        setValue(VhfLang.SSNId,values[VhfLang.SSNId]) 

        setValue(VhfLang.Address1Id,values[VhfLang.Address1Id]) 
        setValue(VhfLang.Address2Id,values[VhfLang.Address2Id]) 
        setValue(VhfLang.ZipcodeId,values[VhfLang.ZipcodeId]) 

        
        setValue(VhfLang.CityId,values[VhfLang.CityId]) 
        setValue(VhfLang.CountryId,values[VhfLang.CountryId]) 
        setValue(VhfLang.PhoneId,values[VhfLang.PhoneId])
        setValue(VhfLang.EmailId,values[VhfLang.EmailId]) 

        setValue(VhfLang.SpecialPostAddressId,sessionStorage.getItem(VhfLang.SpecialPostAddressId)) 
        setValue(VhfLang.NoSwedishPersNoId,sessionStorage.getItem(VhfLang.NoSwedishPersNoId)) 
    }
  
    
    const onSubmit = (values) => {
      sessionStorage.setItem(VhfLang.KeyForSessionForPrivateContact, JSON.stringify(values));
      sessionStorage.setItem(VhfLang.SpecialPostAddressId,specialPostAddress);
      sessionStorage.setItem(VhfLang.NoSwedishPersNoId,noSwedishPersonNo);

      navigate(VhfLang.NavShipInfo, {
        state: {
          values,
        },
      });
    };

    const onError = (values) => {
      isPostBack=true;
  
    };

    const handleSpecialPostAddress=(event)=>{
      setSpecialPostAddress(event.target.checked);
      setValue(VhfLang.SpecialPostAddressId,event.target.checked) 
      isPostBack=true;
    };

    const handleChangeNoSwedishPersonNo=(event)=>{
      unregister(VhfLang.SSNId);
      setNoSwedishPersonNo(event.target.checked);
      setValue(VhfLang.NoSwedishPersNoId,event.target.checked) 
      isPostBack=true;
    }


    const goBack = () => {
      // Read serializable values from the form (fallback to sessionStorage)
      const currentValues = typeof getValues === 'function'
        ? getValues()
        : (JSON.parse(sessionStorage.getItem(VhfLang.KeyForSessionForPrivateContact)) || {});

      navigate(VhfLang.NavStartPage, {
        state: {
          values: currentValues,
        },
      });
    };
    
    
    return(
        
        <Form onSubmit={handleSubmit(onSubmit,onError)}>
      <StepperHelper activeStep={1}></StepperHelper>

  

        <fieldset className="spaceBetweenFieldSetLarge">
        <h2>{VhfLang.PrivateLegendH2}</h2>
          <h3>{VhfLang.PrivateLegend}</h3>
        <InputHelperBootstrap register={register(VhfLang.FirstnameId, { required: true })} error={errors[VhfLang.FirstnameId]} id={VhfLang.FirstnameId} label={VhfLang.FirstnameLabel}  placeholder= {VhfLang.FirstnamePlaceHolder} errorRequiredText= {VhfLang.FirstnameError} ></InputHelperBootstrap>
        <InputHelperBootstrap register={register(VhfLang.LastnameId, { required: true })} error={errors[VhfLang.LastnameId]} id={VhfLang.LastnameId} label={VhfLang.LastnameLabel}  placeholder={VhfLang.LastnamePlaceHolder} errorRequiredText={VhfLang.LastnameError}></InputHelperBootstrap>

        <Row>

              {noSwedishPersonNo==false&&
                        <Col>
              <InputHelperBootstrap register={register(VhfLang.SSNId, {
                    required: true,
                    pattern: /^(\d{2}){0,1}(\d{2})(\d{2})(\d{2})([\+\-\s]?)(\d{3})(\d)$/i})
                    } error={errors[VhfLang.SSNId]}  id={VhfLang.SSNId} label={VhfLang.SSNLabel}  placeholder={VhfLang.SSNPlaceHolder} errorRequiredText={VhfLang.SSNError} errorPatternText={VhfLang.SSNError}></InputHelperBootstrap>
                    </Col>
                  }
                  {noSwedishPersonNo==true&&
                        <Col>
              <InputHelperBootstrap register={register(VhfLang.SSNId, {
                    required: false})
                    }  id={VhfLang.SSNId} label={VhfLang.SSNLabel}  error={errors[VhfLang.SSNId]}   ></InputHelperBootstrap>
                    </Col>
                  }
                    <Col>
                    <br></br>
                    <Form.Check
                    className="marginTopCheckBox"
            inline
            label={VhfLang.NoSwedishPersonNo}
            type={Const.typeCheckBox}
            id={VhfLang.NoSwedishPersonNo}
            checked={noSwedishPersonNo}
            onChange={handleChangeNoSwedishPersonNo}
          />
                    
                    </Col>
            </Row>
            <InputHelperBootstrap register={register(VhfLang.PhoneId, { required: true})} error={errors[VhfLang.PhoneId]}  id={VhfLang.PhoneId} label={VhfLang.PhoneLabel}   errorRequiredText={VhfLang.PhoneError} ></InputHelperBootstrap>
        <InputHelperBootstrap register={register(VhfLang.EmailId, { required: true,pattern: Const.emailRegex })} error={errors[VhfLang.EmailId]}  errorPatternText={VhfLang.EmailPatternError} id={VhfLang.EmailId} label={VhfLang.EmailLabel}  placeholder= {VhfLang.EmailPlaceHolder} errorRequiredText= {VhfLang.EmailError} ></InputHelperBootstrap>
        </fieldset>
        
       
        <fieldset className="spacingBetweenFieldSet">
              <h3>{VhfLang.PrivateAddressLegend}</h3>
              <InputHelperBootstrap register={register(VhfLang.Address1Id, { required: false})}  id={VhfLang.Address1Id} label={VhfLang.Address1Label}  placeholder={VhfLang.Address1PlaceHolder}  ></InputHelperBootstrap>
              <InputHelperBootstrap register={register(VhfLang.Address2Id, { required: true })}  error={errors[VhfLang.Address2Id]} id={VhfLang.Address2Id} label={VhfLang.Address2Label}  errorRequiredText={VhfLang.Address2Error} placeholder={VhfLang.Address2PlaceHolder}   ></InputHelperBootstrap>
            <Row>
                <Col>
                    <InputHelperBootstrap register={register(VhfLang.ZipcodeId, { required: true })} error={errors[VhfLang.ZipcodeId]} id={VhfLang.ZipcodeId} label={VhfLang.ZipcodeLabel}  placeholder={VhfLang.ZipcodePlaceHolder}  errorRequiredText={VhfLang.ZipcodeError} ></InputHelperBootstrap>
                </Col>
                <Col>
                    <InputHelperBootstrap register={register(VhfLang.CityId, { required: true })} error={errors[VhfLang.CityId]} id={VhfLang.CityId} label={VhfLang.CityLabel}  placeholder={VhfLang.CityPlaceHolder} errorRequiredText={VhfLang.CityError} ></InputHelperBootstrap>
                </Col>
                <Col>
                    <InputHelperBootstrap register={register(VhfLang.CountryId, { required: true })} error={errors[VhfLang.CountryId]} id={VhfLang.CountryId} label={VhfLang.CountryLabel} placeholder={VhfLang.CountryPlaceHolder}  errorRequiredText={VhfLang.CountryError} defaultValue="Sverige"></InputHelperBootstrap>
                </Col>
              </Row>
              
              <Form.Check
            inline
            label={VhfLang.SpecialPostAddress}
            type={Const.typeCheckBox}
            id={VhfLang.SpecialPostAddressId}
            checked={specialPostAddress}
            onChange={handleSpecialPostAddress}
          />
          <br></br> <br></br>
              <div className="float-end">
            <Button variant="back" type="button"  onClick={goBack} className="button-margin">
            {VhfLang.ButtonPreviousDisplay}
                  </Button>
        <Button variant="forward" type="submit" className="button-margin">
        {VhfLang.ButtonNextDisplay}
                  </Button>
                  </div>
            </fieldset>
         
                  

        </Form>
        

    )
}
export default PrivateContact